export default ({ text, cols }) => {
  const arr = [];

  for (let i = 1; i <= cols; i += 1) {
    arr.push({ title: `Колонка ${i}`, value: text[`columns${i}`], paramName: `columns${i}` });
  }
  return arr;
};
